var React = require('react');

function IconDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.0638 16.9973C12.2663 16.9847 12.4587 16.9047 12.6105 16.7702L21.6962 8.59214C21.8768 8.43051 21.9857 8.20344 21.9987 7.96147C22.0118 7.71934 21.9278 7.48198 21.7656 7.30179C21.6035 7.12162 21.3761 7.01355 21.1341 7.00119C20.892 6.98883 20.6549 7.07344 20.4753 7.23618L12 14.8674L3.52474 7.23618C3.34507 7.07345 3.10806 6.98883 2.86595 7.00119C2.62385 7.01355 2.39649 7.12162 2.23441 7.30179C2.07217 7.48196 1.98819 7.71933 2.00134 7.96147C2.01433 8.20343 2.12318 8.43049 2.30381 8.59214L11.3895 16.7702C11.5741 16.9344 11.8176 17.0164 12.0638 16.9973Z","fill":"black"}));
}

IconDown.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = IconDown;

IconDown.default = IconDown;
